import styled from "styled-components";

export const Alert = styled.div`
  border-left-color: ${({ theme }) => theme.colors.purple};
  border-left-width: 4px;
  border-left-style: solid;
  background: rgba(33, 128, 232, 0.16);
  width: 100%;
  margin: 10px 0px;
  padding: 8px 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: 768px) {
    padding: 5px 15px;
  }
`;

export const TextAlert = styled.div`
  color: ${({ theme }) => theme.colors.purple};
  font-size: ${({ textFontSize }) => textFontSize || "1rem"};
`;

export const IconAlert = styled.span`
  color: ${({ theme }) => theme.colors.purple};
  margin-right: 10px;
  font-size: 1.5rem;
`;
